var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"descBox"},[_c('div',{staticClass:"leftItem"},[_c('div',{staticClass:"name"},[_vm._v("个人介绍")]),_c('div',{staticClass:"desc"},[_vm._v("您还没有个人介绍，点击加号编辑")])]),_c('div',{staticClass:"rightItem"},[_c('img',{staticClass:"addIcon",attrs:{"src":"","alt":""}})])])])
}]

export { render, staticRenderFns }